export enum DxmDownloadStatus {
  stop = "stop",
  downloading = "downloading",
  finished = "finished",
}
